import { render, staticRenderFns } from "./NormalFrame.vue?vue&type=template&id=0fa65a2f&scoped=true&"
import script from "./NormalFrame.vue?vue&type=script&lang=js&"
export * from "./NormalFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa65a2f",
  null
  
)

export default component.exports